import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import { signItem } from "../states/atoms/signState";
import { getAuth } from "../api";
import { useLocation } from "react-use";
import Loader from "../components/common/Loader";
import useTransition from "react-transition-state";
import { MENU } from "../data/menus";

const withNavigation = (WrappedComponent) => (props) => {
  const { pathname } = useLocation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [signInfo, setSignInfo] = useRecoilState(signItem);
  const [loading, setLoading] = useState(0);
  const [{ status }, toggle] = useTransition({
    timeout: 500,
    initialEntered: true,
    preEnter: true,
  });
  const [[menus, dropdowns], setMenus] = useState([null, null]);

  const getAuthResult = async (token) => {
    const res = await queryClient.fetchQuery(["auth/check"], {
      queryFn: () => getAuth(token),
      staleTime: 0,
    });
    const { result, error, data: info } = res;
    if (result) {
      setSignInfo({ result, info, error: null });
      const { token, role } = info;
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      if (pathname === "/") {
        switch (role) {
          case "student":
            return navigate("/student");
          case "parent":
            return navigate("/parent");
          default:
            return navigate("/lecture");
        }
      }
    } else {
      setSignInfo({ result: false, info: null, error });
      navigate("/signout");
    }
    queryClient.invalidateQueries("auth/check");
    setLoading(1);
    toggle();
    if (result) {
      if (
        pathname === "/" &&
        (info.role === "admin" || info.role === "teacher")
      ) {
        navigate("/lecture");
      }
    }
  };

  useEffect(() => {
    if (
      (signInfo && signInfo.result && signInfo.info) ||
      !!localStorage.getItem("token")
    ) {
      let token = localStorage.getItem("token");
      const role = localStorage.getItem("role") || "none";
      setMenus(MENU[role]);
      if (signInfo && "info" in signInfo && signInfo.info) {
        token = "token" in signInfo.info ? signInfo.info.token : token;
      }
      setLoading(0);
      getAuthResult(token);
    } else {
      setSignInfo({ result: false, info: null, error: null });
      setLoading(1);
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return (
    <>
      <Navbar
        menus={menus}
        dropdown={dropdowns}
        info={"info" in signInfo && signInfo.info}
      />
      {loading === 0 && (
        <Loader className={`basic-transition h-screen ${status}`} />
      )}
      {loading === 1 && <WrappedComponent {...props} />}
    </>
  );
};

export default withNavigation;
